import { AccordionLOCGenerator } from '@app/code/src/components/LoggedOutCodeGeneratorV2/AccordionLOCGenerator'
import { Container } from '@dtx-company/design-system/src'
import { DESKTOP_LOCG_EMAIL_PASSWORD_FIELDS_ABOVE_THE_FOLD } from '@app/analytics/src/constants/optimizely'
import { FC, useEffect } from 'react'
import { ScrollableLOCGenerator } from '@app/code/src/components/LoggedOutCodeGeneratorV2/ScrollableLOCGenerator'
import { fireAnalyticsEvent } from '@dtx-company/inter-app/src/event-tracking/helpers/fireAnalyticsEvent'
import { selectSection } from '../../machines/locg/locgSelectors'
import { useFlowFeature } from '@dtx-company/inter-app/src/hooks/useFlowFeature/useFlowFeature'
import { useGlobalServices } from '@app/common/src/hooks/useGlobalServices'
import { useSelector } from '@xstate/react'

export const LoggedOutCodeGenerator: FC = () => {
  const [version] = useFlowFeature(DESKTOP_LOCG_EMAIL_PASSWORD_FIELDS_ABOVE_THE_FOLD)
  const { locgService } = useGlobalServices()
  const currentSection = useSelector(locgService, selectSection)
  useEffect(() => {
    fireAnalyticsEvent('LoggedOutGenerator_Section_View', { value: currentSection })
  }, [currentSection])
  useEffect(() => {
    fireAnalyticsEvent('LoggedOutGenerator_Desktop_LOCG_email_password_fields_above_the_fold', {
      value: version
    })
  }, [version])

  return (
    <>
      {version ? (
        <AccordionLOCGenerator />
      ) : (
        <Container maxWidth="xl" disableGutters>
          <ScrollableLOCGenerator />
        </Container>
      )}
    </>
  )
}
